import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ISalesState }          from 'Redux/Slices/Sales/SalesSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findMauDauWauRequest = (state: Draft<ISalesState>, { type }: PayloadAction) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findMauDauWauSuccess = (state: Draft<ISalesState>, { type, payload }: PayloadAction<{
  dau: { statDate: string, count: number }[],
  wau: { statDate: string, count: number }[],
  mau: { statDate: string, count: number }[],
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = {
    ...state.entries,
    dau: payload.dau,
    wau: payload.wau,
    mau: payload.mau,
  };
};

export const findMauDauWauFailure = (state: Draft<ISalesState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
